/*
 *
 * File JS per animazione
 *
 */
// import gsap from "gsap";

import ScrollMagic from "scrollmagic";
// import { gsap, ScrollTrigger } from "gsap/all";
// gsap.registerPlugin(ScrollTrigger);

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./animate-in.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const animateIn = () => {
    let controllerAnimateIn = new ScrollMagic.Controller();
    let fade = document.querySelectorAll(".fade");
    // ScrollTrigger.config({ ignoreMobileResize: true });
    // let windowWidth = window.innerWidth;

    if (!fade) {
        return;
    } else {
        fade.forEach((el) => {
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: "onEnter",
                reverse: false,
                offset: 80,
            })
                .setClassToggle(el, "animate")
                .addTo(controllerAnimateIn);
        });
    }

    // const allParallax = gsap.utils.toArray(".image");
    // allParallax.forEach((parallax) => {
    //     gsap.to(parallax, {
    //         yPercent: 18,
    //         ease: "none",
    //         scrollTrigger: {
    //             trigger: parallax,
    //             start: "top",
    //             end: "bottom",
    //             scrub: true,
    //         },
    //     });
    // });
};

export default animateIn;

//--------------------------------------------------------------------//
